define('numeric',['require','knockout'],function (require) {
    var ko = require('knockout');

    /**
     * Will block the input of any characters that are not 0-9.
     * Not keypress based, so cmd+A, arrow keys, and so on are not affected.
     * Example Usage:
     * <input type="text" data-bind="textInput: duration, integer: duration" />
     */
    ko.bindingHandlers.integer = {
        update: function (element, valueAccessor) {
            var value = valueAccessor();
            value(value().toString().replace(/[^0-9]/g, ''));
        }
    };
});

